import { BatchCampaignsProps } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/Types'
import {
  useCreateBatchCampaignsMachine
} from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/useCreateBatchCampaignsMachine'
import { EventId, StateId } from './Types'
import { Modal } from 'almanac-ui/Modal'
import {
  ModalBackContainer
} from 'screens/Campaigns/components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalBackContainer'
import {
  CreateBatch
} from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/CreateBatch'
import { useCallback } from 'react'
import { Analysing } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/Analysing/Analysing'
import { Review } from 'screens/Campaigns/components/BatchCreateCampaignsModal/BatchCampaigns/Review/Review'

export const BatchCampaigns = ({ numberOfCampaigns, onExit, brandPlan }: BatchCampaignsProps) => {
  const [current, send] = useCreateBatchCampaignsMachine({ brandPlanId: brandPlan.id }, {
    actions: {
      close: onExit,
    },
    context: {
      number_of_campaigns: numberOfCampaigns,
      topics: [''],
      start_date: '',
      campaigns: [],
      media: [],
      sources: [],
      transient: {
        abortController: new AbortController(),
      },
    },
  })

  const handleBack = useCallback(() => {
    send({ type: EventId.Back })
  }, [send])

  return (
    <>
      {current.matches(StateId.CreateBatch) && (
        <CreateBatch
          numberOfCampaigns={numberOfCampaigns}
          startDate={current.context.start_date}
          topics={current.context.topics}
          onSubmit={(vars) => send({ type: EventId.PrepareBatch, ...vars })}
        />
      )}
      {current.matches(StateId.Analysing) && (
        <Analysing />
      )}
      {current.matches(StateId.Review) && (
        <Review
          campaigns={current.context.campaigns.map(campaign => ({ ...campaign, crosspost_frequency: brandPlan.crosspost_frequency }))}
          onSubmit={(vars) => {
            send({ type: EventId.Finish, ...vars })
          }}
        />
      )}
      <ModalBackContainer>
        <Modal.FooterButton onPress={handleBack} size="lg" variant="tertiary">
          Back
        </Modal.FooterButton>
      </ModalBackContainer>
    </>
  )
}
